import React from 'react'
import styles from './style.module.css'


const MediaTypeBadge = (props: any) => {
    return (
        <span className={`badge text-capitalize ms-2 ${styles.mediaTypeBadge} ${props.type == 'audio' ? styles.audioMedia : 'bg-warning'}`}>{props.type || 'audio'}</span>
    )
}

export default MediaTypeBadge
